import news1 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_hackathon_2025.webp";
import news2 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_comprehensive-investor.webp";
import news3 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_global_instant.webp";
import news4 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_empowers_students.webp";
import news5 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_vaibhav_poonekar.webp";
import news6 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_eric.webp";
import news7 from "../../../../asset/images/media/press_release/press_release_thumbnail/decimal_point_analytics_and_prmia.webp";
import news8 from "../../../../asset/images/media/press_release/press_release_thumbnail/decimal_point_analytics_announces_fund.webp";
import news9 from "../../../../asset/images/media/press_release/press_release_thumbnail/oracle_global_leaders.webp";
import news10 from "../../../../asset/images/media/press_release/press_release_thumbnail/dilip_sah.webp";
import news11 from "../../../../asset/images/media/press_release/press_release_thumbnail/gautam_naidu.webp";
import news12 from "../../../../asset/images/media/press_release/press_release_thumbnail/dpa_smartcloud.webp";
import news13 from "../../../../asset/images/media/press_release/press_release_thumbnail/perfect_storm_awaiting.webp";
import news14 from "../../../../asset/images/media/press_release/press_release_thumbnail/decimal_point_analytics_receives_grant.webp";
import news15 from "../../../../asset/images/media/press_release/press_release_thumbnail/plans_overseas.webp";
import news16 from "../../../../asset/images/media/press_release/press_release_thumbnail/india_emerging_as_global.webp";
import news17 from "../../../../asset/images/media/press_release/press_release_thumbnail/central_bank_digital_currencies.webp";
import news18 from "../../../../asset/images/media/press_release/press_release_thumbnail/office_in_nashik.webp";
import news19 from "../../../../asset/images/media/press_release/press_release_thumbnail/wins_canadian_reg_tech.webp";
import news20 from "../../../../asset/images/media/press_release/press_release_thumbnail/transformative_impact.webp";
import news21 from "../../../../asset/images/media/press_release/press_release_thumbnail/dpa_hires_intern.webp";

const Press_Release_data = [
    {
        type: "internal",
        link: "/decimal-point-analytics-hires-interns-full-time-under-csr-initiative",
        imgsrc: news21,
        heading: "Decimal Point Analytics Hires Interns Full-Time Under CSR Initiative",
        date: "May 06, 2025",
        year: 2025,
        subheading: "Decimal Point Analytics has successfully transitioned six interns into full time employees under its CSR initiative, ‘Dnyanodapi Dhanodapi.’ This annual program, now in its third edition, is dedicated to providing corporate exposure to deserving young minds from rural and economically disadvantaged backgrounds who often lack access to professional training and career-building opportunities."
    },
    {
        type: "internal",
        link: "/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science",
        imgsrc: news6,
        heading: "Decimal Point Analytics Appoints Eric Yuen as Partner and Head of Data Science",
        date: "Apr 08, 2025",
        year: 2025,
        subheading: "Decimal Point Analytics announces the appointment of Eric Yuen as Partner and Head of Data Science. With over 20 years of experience across Blackstone and JPMorgan Chase, Eric brings deep expertise in finance, technology, and data science. His leadership will accelerate DPA’s mission to deliver AI-powered insights and innovation to global financial institutions."
    },
    {
        type: "internal",
        link: "/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions",
        imgsrc: news5,
        heading: "Decimal Point Analytics Elevates Vaibhav Poonekar To CTO In Key Internal Leadership Promotions",
        date: "Apr 04, 2025",
        year: 2025,
        subheading: "Decimal Point Analytics announces key leadership promotions, including the elevation of Vaibhav Poonekar to Chief Technology Officer (CTO). This strategic move reinforces the firm’s focus on advancing innovation, enhancing client-centric solutions, and nurturing internal talent. Several senior leaders across core functions have also been promoted, reflecting DPA’s ongoing commitment to operational excellence and long-term growth."
    },
    {
        type: "internal",
        link: "/decimal-point-analytics-hosts-hackathon-2025",
        imgsrc: news1,
        heading: "Decimal Point Analytics (DPA) Hosts Hackathon 2025",
        date: "Jan 10, 2025",
        year: 2025,
        subheading: "Decimal Point Analytics (DPA) hosted its inaugural Hackathon 2025 to encourage innovation and collaboration among employees. The event focused on six strategic themes aligned with DPA's core areas of financial analytics and technology: AI and Machine Learning for Private Equity Insights, Automated Compliance and Fraud Detection, Sustainable Investment Analysis, Customer Sentiment Analysis in Financial Services, Enhanced Data Visualization for Financial Insights, and Financial Knowledge Graphs Using NLP"
    },
    {
        type: "internal",
        link: "/decimal-point-analytics-launches-comprehensive-investor-relationship-management-solutions",
        imgsrc: news2,
        heading: "Decimal Point Analytics Launches Comprehensive Investor Relationship Management Solutions",
        date: "Nov 15, 2024",
        year: 2024,
        subheading: "Our CEO, Shailesh Dhuri, is featured in AP News, where he discusses Decimal Point Analytics’ expanded Investor Relationship Management offerings. He highlights how our innovative solutions, leveraging AI, automation, and a human-in-the-loop approach, are designed to elevate client engagement, streamline investor communications, and help financial firms build long-term investor trust."
    },
    {
        type: "internal",
        link: "/global-and-instant-magnification-of-stupidity-as-we-watch-the-dream-of-the-internet-failing",
        imgsrc: news3,
        heading: "Global and instant magnification of stupidity as we watch the dream of the Internet failing",
        date: "Jul 27, 2024",
        year: 2024,
        subheading: "Our CEO, Shailesh Dhuri, reflects on the recent global disruption caused by a design flaw in the Internet’s architecture. On July 19, 2024, a tiny error led to a worldwide halt of essential services, highlighting the shift from the Internet’s original decentralized design to a centralized model. Shailesh points out that this concentration of power, driven by technology corporations and governments, has created vulnerabilities. He questions whether we will ever return to the Internet's foundational principles of resilience and decentralization."
    },
    {
        type: "internal",
        link: "/decimal-point-analytics-plans-overseas-expansion",
        imgsrc: news15,
        heading: "Decimal Point Analytics plans overseas expansion",
        date: "Jan 16, 2024",
        year: 2024,
        subheading: "Decimal Point Analytics (DPA), a full-service management consulting firm specialising in Financial Research, Data Analytics & AI, is planning to expand its base internationally in 2024 to serve its clients better, a top executive said. “We are committed to serving our clients wherever they operate. Beyond our existing offices in India and strategic overseas locations, we will explore further global expansion to bring DPA’s expertise closer to international clients,” Shailesh Dhuri, Chief Executive Officer, Decimal Point Analytics said."
    },
    {
        type: "internal",
        link: "/decimal-point-analytics-empowers-underprivileged-students-through-dnyanodapi-dhanodapi-program",
        imgsrc: news4,
        heading: "Decimal Point Analytics Empowers Underprivileged Students Through Dnyanodapi Dhanodapi Program",
        date: "Jun 25, 2024",
        year: 2024,
        subheading: 'Shailesh Dhuri, CEO of Decimal Point Analytics, emphasizes the impact of the "Dnyanodapi Dhanodapi" program, which offers underprivileged students in financial analytics paid internships, mentorship, and career guidance. Named for its focus on knowledge and wealth, the initiative promotes diversity with a notable 2:1 female-to-male applicant ratio in 2024, highlighting its role in nurturing talent and cultivating innovation within the industry.'
    },
    {
        type: "internal",
        link: "/dilip-sah-joins-decimal-point-analytics-as-chief-technology-officer",
        imgsrc: news10,
        heading: "Dilip Sah Joins Decimal Point Analytics as Chief Technology Officer",
        date: "Jun 03, 2024",
        year: 2024,
        subheading: "Dilip Sah, appointed as Chief Technology Officer (CTO) at Decimal Point Analytics, brings over 20 years of experience in data, AI, and digital product development to his role. His expertise will drive our company's technological innovation and elevate our financial analytics solutions, marking a significant milestone in our commitment to delivering exceptional value to clients"
    },
    {
        type: "internal",
        link: "/central-bank-digital-currencies-the-new-era-of-money",
        imgsrc: news17,
        heading: "Central Bank Digital Currencies (CBDCs): The New Era of Money",
        date: "Jan 10, 2024",
        year: 2024,
        subheading: "Shailesh Dhuri, CEO of Decimal Point Analytics was recently featured in the digital print of PCQuest for outlining his vision for a future powered by Central Bank Digital Currencies (CBDCs). In an interview with PCQuest, he highlighted the potential of CBDCs to revolutionize payments, foster transnational collaboration, and even combat illegal activities through the use of smart contracts."
    },
    {
        type: "internal",
        link: "/gautam-naidu-joins-decimal-point-analytics-as-chief-revenue-officer-in-mumbai",
        imgsrc: news11,
        heading: "Gautam Naidu joins Decimal Point Analytics as Chief Revenue Officer in Mumbai",
        date: "Jan 10, 2024",
        year: 2024,
        subheading: "Decimal Point Analytics, a leading provider of data analytics, AI & market research solutions, is thrilled to announce the appointment of Gautam Naidu as its new Chief Revenue Officer (CRO). In his role, Mr. Naidu will spearhead revenue generation strategies, drive business development initiatives, and play a pivotal role in furthering the company's growth trajectory."
    },
    {
        type: "internal",
        link: "/decimal-point-analytics-wins-canadian-reg-tech-award-for-best-esg-solution-2023",
        imgsrc: news19,
        heading: "Decimal Point Analytics Wins Canadian Reg Tech Award for Best ESG Solution 2023",
        date: "Nov 28, 2023",
        year: 2023,
        subheading: "Toronto - Decimal Point Analytics, a leader in innovative financial technology solutions, has been named the winner in the prestigious Canadian RegTech Awards for its exceptional contributions to Environmental, Social, and Governance (ESG) solutions. This recognition underscores the company's unwavering commitment to fostering sustainable and responsible business practices."
    },
    {
        type: "internal",
        link: "/india-emerging-as-a-global-trendsetter-in-esg-disclosures",
        imgsrc: news16,
        heading: "India emerging as a global trendsetter in ESG disclosures",
        date: "Oct 25, 2023",
        year: 2023,
        subheading: "SEBI’s aggressive stance has ensured India has among the most advanced ESG reporting regulatory regimes in the world, says Shailesh Dhuri, CEO, Decimal Point Analytics, and suggests areas for further action."
    },
    {
        type: "internal",
        link: "/oracle-global-leaders-recognizes-decimal-point-analytics-as-isv-of-the-year-2023",
        imgsrc: news9,
        heading: "Oracle Global Leaders Recognizes Decimal Point Analytics as ISV of the Year 2023",
        date: "Sept 20, 2023",
        year: 2023,
        subheading: "Decimal Point Analytics, a leading provider of advanced analytics, research, and data solutions, is proud to announce that it has received the prestigious Intel Oracle Global Leaders Award for ISV of the Year in the APAC region for the year 2023. This award recognizes Decimal Point Analytics for its exceptional contributions in leveraging Oracle cloud technologies to drive innovation and deliver outstanding solutions to clients across the globe."
    },
    {
        type: "internal",
        link: "/transformative-impact-of-gpt-on-the-analytics-landscape",
        imgsrc: news20,
        heading: "Transformative Impact of GPTs on the Analytics Landscape",
        date: "Aug 21, 2023",
        year: 2023,
        subheading: "Generative Pre-trained Transformers or GPTs as we commonly know them, are a powerful family of neural network models, leading the way in generative artificial intelligence. GPTs are already having a fundamental impact across many walks of life – the way we work, the way we think, among others. While scientists have been attempting to develop generative tools in the Artificial Intelligence space for decades, the recent success of GPTs can be attributed to three critical factors:"
    },
    {
        type: "internal",
        link: "/decimal-pointa-analytics-and-prmia-collaborate-for-successful-quantifying-esg-risk-event",
        imgsrc: news7,
        heading: 'Decimal Point Analytics and PRMIA Collaborate for Successful "Quantifying ESG Risk" Event',
        date: "Jun 05, 2023",
        year: 2023,
        subheading: '[New York] - Decimal Point Analytics, a leading provider of data analytics solutions, partnered with the Professional Risk Managers International Association (PRMIA) to host the highly successful "Quantifying ESG Risk" event. The event took place on June 1st at New York Bar Association in New York, featuring a keynote session by Shailesh Dhuri, CEO of Decimal Point Analytics, and an esteemed panel of industry experts.'
    },
    {
        type: "internal",
        link: "/decimal-point-analytics-inaugurated-its-green-energy-office-in-nashik",
        imgsrc: news18,
        heading: "Decimal Point Analytics inaugurated its 100% green energy office in Nashik",
        date: "Jan 13, 2023",
        year: 2023,
        subheading: 'Decimal Point Analytics (DPA) inaugurates new green energy office space in Nashik. Speaking on the new office launch Mr. Shailesh Dhuri, CEO of Decimal Point Analytics said, "We believe our green energy office space would help us contribute to our commitment towards Net Zero emissions alongside cultivating a positive and professional work environment for our colleagues."'
    },
    {
        type: "internal",
        link: "/decimal-point-analytics-receives-grant-funding-to-develop-tokenization-solutions",
        imgsrc: news14,
        heading: "Decimal Point Analytics receives grant funding to develop Tokenization solutions",
        date: "Jan 11, 2023",
        year: 2023,
        subheading: "Decimal Point Analytics announced to receive an esteemed grant of up to USD 7,50,000 from The Hashgraph Association (THA) to develop tokenization solutions for traditional asset markets."
    },
    {
        type: "internal",
        link: "/fintechentity",
        imgsrc: news12,
        heading: "DPA SmartCloud recognized as a “Fintech Entity” by International Financial Services Centres Authority (IFSCA).",
        date: "Dec 20, 2022",
        year: 2022,
        subheading: "DPA SmartCloud IFSC Private Limited, a wholly owned subsidiary of Decimal Point Analytics (DPA), has become India's first ever fintech start-up to be authorized as a 'Fintech Entity' by the International Financial Services Centres Authority (IFSCA), the omnibus regulator of the financial SEZ at Gift City, Gujarat."
    },
    {
        type: "external",
        link: "https://www.business-standard.com/content/press-releases-ani/malware-and-ransomware-attacks-increased-by-358-per-cent-and-435-per-cent-respectively-the-global-risks-report-2022-122090100993_1.html",
        imgsrc: news13,
        heading: "A “perfect storm” awaiting the financial sector due to deepened global divisions!",
        date: "Sep 05, 2022",
        year: 2022,
        subheading: "The next financial crisis could arise by repricing of financial risks emanating from developed economies. This was the key point from our CEO Shailesh Dhuri during a webinar hosted by PRMIA (Professional risk managers international association). The agenda of discussion among 150 risk managers across the globe were “What risks keep CROs awake”? The webinar was graced with well-known faces in the industry, including CFOs and CROs of various companies. Other factors for the emerging financial risk included -Impacts of COVID-19, Technological Changes, etc."
    },
    {
        type: "external",
        link: "https://www.thehindu.com/business/Industry/decimal-point-analytics-raises-35-crore/article65467387.ece",
        imgsrc: news8,
        heading: "Decimal Point Analytics announces a fund raise of Rs 35 crore (USD 4.7m) by a large global institutional investor",
        date: "May 27, 2022",
        year: 2022,
        subheading: "Decimal Point Analytics (DPA), which provides data analytics products and services to global hedge funds, investment banks, venture capital firms, private equity funds among others, announced fund raise by a large global institutional investor."
    },
    {
        type: "external",
        link: "https://www.prfree.org/@decimalp/decimal-point-analytics-announces-the-launchdate-of-its-asset-allocation-platform-powered-by-quantum-computing-in-a-world-first-implementation-6rm5rnyjbkw4",
        imgsrc: news4,
        heading: "Decimal Point Analytics announces the launchdate of its Asset Allocation platform powered by Quantum Computing in a world first implementation",
        date: "Oct 27, 2021",
        year: 2021,
        subheading: "Mumbai (October 27, 2021) – Financial industry is always on the lookout for the latest technical innovation to get an edge in the market. Harnessing the power of Quantum computing will be the next big breakthrough for the financial services industry."
    },
    {
        type: "external",
        link: "https://www.prfree.org/@decimalp/prosper-with-knowledge-and-wealth-program-by-decimal-point-analytics-yrkd54qqrm5x",
        imgsrc: news4,
        heading: "Prosper With Knowledge and Wealth Program by Decimal Point Analytics",
        date: "Sep 23, 2021",
        year: 2021,
        subheading: "Decimal Point Analytics (DPA) proudly launched the Dnyanodapi Dhanodapi Program on this World Gratitude Day. The Sanskrit name of this program means “Prosper with Knowledge and Wealth”. This program aims to uplift those graduates who come from a financially weak background but are exceptionally bright in academics."
    },
    {
        type: "external",
        link: "https://www.openpr.com/news/2384101/decimal-point-analytics-achieves-zero-carbon-emissions-at-their",
        imgsrc: news4,
        heading: "Decimal Point Analytics achieves zero carbon emissions at their analytics centers",
        date: "Sep 07, 2021",
        year: 2021,
        subheading: "Decimal Point Analytics (DPA) today announced that it has taken steps to ensure zero carbon emissions from its analytics centers in Mumbai and Nashik, India. It has already switched to 100% Green Energy usage at its Mumbai office. When we think about carbon emissions, we visualize plumes of dark smoke emanating from industrial chimneys, but the airconditioned offices running computers also contribute towards carbon emissions in equal proportions. Hence, DPA took a decision to ensure that its analytics centers run only on green power."
    },
    {
        type: "external",
        link: "http://www.prfree.org/@decimalp/decimal-point-analytics-urges-all-its-employees-to-fightback-corona-eqmje54q6kr6",
        imgsrc: news4,
        heading: "Decimal Point Analytics urges all its employees to fightback Corona",
        date: "Apr 26, 2021",
        year: 2021,
        subheading: "Decimal Point Analytics has commenced an initiative to encourage its employees and their families to get Covid-19 vaccination. With the onset of the 2nd wave of corona pandemic, our country is facing a havoc situation. The rampage in the number of corona cases has made it important for people to go back to the basic rules- Mandatory masks, staying at home unless very important and maintaining social distance."
    },
    {
        type: "external",
        link: "https://www.pr.com/press-release/835244",
        imgsrc: news4,
        heading: "Hiring Figures Are Through the Roof at Decimal Point Analytics During the Pandemic Season",
        date: "Apr 25, 2021",
        year: 2021,
        subheading: "Mumbai, India, April 25, 2021 --(PR.com)-- The coronavirus pandemic is truly an unprecedented challenge for all of humanity. Since the onset of the pandemic, enterprises declaring Layoffs and Furloughs have become commonplace across the globe. With the entire world economy coming to a grinding halt this was not a surprising response."
    },
    {
        type: "external",
        link: "https://www.pr.com/press-release/833602",
        imgsrc: news4,
        heading: 'Decimal Point Analytics Pvt. Ltd. Wins "Indian SME of the Year Award"',
        date: "Mar 31, 2021",
        year: 2021,
        subheading: 'Mumbai, India, March 31, 2021 --(PR.com)-- The Indo-French Chamber of Commerce and Industry (IFCCI) organised the Third Edition of the prestigious Indo French Business Awards 2021 on 24th March at New Delhi. The event had more than 120 nominations under multiple award categories. Decimal Point Analytics Pvt. Ltd., a leading technology-enabled financial research consulting company received the "Indian SME of the Year" award.'
    },
    {
        type: "external",
        link: "https://www.pr.com/press-release/820383",
        imgsrc: news4,
        heading: "Decimal Point Analytics CEO, Mr. Shailesh Dhuri Says India Needs a Rate Cut of 250 BPS in the Next Seven Months",
        date: "Sep 04, 2020",
        year: 2020,
        subheading: "Mumbai, India, September 04, 2020 --(PR.com)-- Recently, Indian GDP for June 2020 Quarter printed -23.9% growth. Interestingly, just a few weeks before this print, RBI Monetary Policy Committee announced that it was holding rates steady because Consumer Price Index (CPI) inflation was at 6.93%, outside the target range of 2% to 6%."
    },
    {
        type: "external",
        link: "https://www.marketpressrelease.com/Decimal-Point-Analytics-employees-contribute-prize-money-to-feed-the-less-privileged-1596541649.html",
        imgsrc: news4,
        heading: "Decimal Point Analytics employees contribute prize money to feed the less privileged",
        date: "Aug 04, 2020",
        year: 2020,
        subheading: "Two teams of Decimal Point employees used their prize money to buy food supplies to support Mission30M by the Robin Hood Army.Financial industry is always on the lookout for the latest technical innovation to get an edge in the market. Harnessing the power of Quantum computing will be the next big breakthrough for the financial services industry."
    },
    {
        type: "external",
        link: "https://www.1888pressrelease.com/laplace-s-demon-and-limits-to-central-banks-ability-to-stab-pr-673098.html",
        imgsrc: news4,
        heading: "Laplace’s Demon and Limits to Central Banks’ Ability to Stabilize Economy",
        date: "Apr 12, 2020",
        year: 2020,
        subheading: "In last three weeks, the major central banks in the world have gone in an overdrive to stabilize the markets by actively participating in the market and the market is hoping for a V shaped recovery post Covid19 pandemic curve flattening."
    },
    {
        type: "external",
        link: "https://www.prlog.org/12816128-iatrogenesis-of-social-distancing-thoughts-on-flaws-in-the-deeper-structure-of-society.html",
        imgsrc: news4,
        heading: "Iatrogenesis of Social Distancing: Thoughts on flaws in the deeper structure of society",
        date: "Mar 26, 2020",
        year: 2020,
        subheading: "MUMBAI, India - March 26, 2020 - PRLog -- We are in the midst of a global pandemic with a financial crisis staring right at us. Social distancing is being followed as a preventive measure to flatten the curve. Shailesh Dhuri, CEO Decimal Point Analytics, discusses the iatrogenesis of social distancing in his recently published article."
    },
    {
        type: "external",
        link: "http://www.prfree.org/@decimalp/beginning-of-etf-shock-p7kea7jprkwx",
        imgsrc: news4,
        heading: "Beginning of ETF Shock",
        date: "Mar 23, 2020",
        year: 2020,
        subheading: "Last week Shailesh Dhuri shared his views in an article about the folly of ETF’s and how the COVID-19 led supply disruption, is leading to a liquidity crunch. The central bankers are finding it difficult to service the liquidity requirements of the real economy leaving precious nothing for the financial markets. This has put about two trillion worth of ETF’s at pricing risk."
    },
    {
        type: "external",
        link: "https://www.openpr.com/news/1975128/funding-stress-in-dollar-market-at-a-record-high-in-the-last-two",
        imgsrc: news4,
        heading: "Funding Stress in Dollar Market at a record high in the last two decade",
        date: "Mar 19, 2020",
        year: 2020,
        subheading: "Quantitative easing programs have injected liquidity to the tune of $4000 billion in the markets since the start of 2010. However, if you look closely at the banks today there is a liquidity shortfall to the tune of $500 billion."
    },
    {
        type: "external",
        link: "https://www.marketpressrelease.com/Shailesh-Dhuri-CEO-of-Decimal-Point-Analytics-discusses-about-COVID-19-and-the-Folly-of-ETFs-1584513466.html",
        imgsrc: news4,
        heading: "Shailesh Dhuri, CEO of Decimal Point Analytics discusses about 'COVID-19 and the Folly of ETFs'",
        date: "Mar 18, 2020",
        year: 2020,
        subheading: "In the recently published article Shailesh Dhuri, CEO Decimal Point Analytics discusses some of the apparent similarities between the Great Financial Crisis of 2008 and the emerging situation at present."
    },
    {
        type: "external",
        link: "https://www.openpr.com/news/1927571/institute-of-actuaries-of-india-has-announced-weather",
        imgsrc: news4,
        heading: 'Institute of Actuaries of India has announced "Weather Hackathon January 2020" powered by Decimal Point Analytics',
        date: "Feb 11, 2020",
        year: 2020,
        subheading: 'Institute of Actuaries of India has announced "Weather Hackathon January 2020." This is the first-ever hackathon to be organized by the Institute of Actuaries of India (IAI) and it is open to IAI students, Associates, and fellow members. The hackathon is centered around the theme of "Climate change and sustainability."'
    },
    {
        type: "external",
        link: "http://www.prfree.org/@decimalp/decimal-point-analytics-announces-the-top-five-contestants-of-technopulse-its-online-machine-learning-challenge-3rmwydr8amn4",
        imgsrc: news4,
        heading: "Decimal Point Analytics announces the top five contestants of ‘TechnoPulse’, its online Machine Learning challenge",
        date: "Feb 13, 2020",
        year: 2020,
        subheading: "The TechnoPulse final winner will get a brand-new laptop. Top 3 successful contestants will get an opportunity to work with its ML team. Decimal Point Analytics has published the leaderboard of TechnoPulse, the online Machine Learning coding challenge."
    },
    {
        type: "external",
        link: "https://www.openpr.com/news/1743666/decimal-point-releases-the-latest-economic-dashboard-for-india.html",
        imgsrc: news4,
        heading: "Decimal Point releases the latest Economic Dashboard for India",
        date: "May 17, 2019",
        year: 2019,
        subheading: "Decimal Point Analytics has released a dashboard based on Indian economic indicators generated from data published by EcoPulse.  EcoPulse is a platform which delivers global economic indicators covering currencies, commodities and other markets."
    },
    {
        type: "external",
        link: "https://www.openpr.com/news/1030797/how-can-india-leverage-rising-crude-oil-prices-to-help-the-domestic-economy.html",
        imgsrc: news4,
        heading: "How can India leverage rising crude oil prices to help the domestic economy?",
        date: "Apr 26, 2018",
        year: 2018,
        subheading: "The international crude oil prices are near four-year highs at mid $70s per barrel due to geopolitical reasons and artificial supply constraints. With a five percent ethanol blending norm in India for petrol, oil marketing companies are procuring domestic ethanol which is costlier than imported petrol."
    },
    {
        type: "external",
        link: "https://www.prlog.org/12706613-rethinking-corporate-governance-framework-in-the-digital-world.html",
        imgsrc: news4,
        heading: "Rethinking Corporate Governance Framework in the Digital World",
        date: "May 4, 2018",
        year: 2018,
        subheading: "We implicitly believe that democracy represents the people's will expressed through the legal institutions and infrastructure in the country. However, the author points out that much of the customs, rules, and regulation are also the product of the technology of the times when it was established."
    },
    {
        type: "external",
        link: "https://www.prlog.org/12716242-decimal-point-analytics-launches-the-beta-of-imagepulse-for-predicting-the-financial-status.html",
        imgsrc: news4,
        heading: "Decimal Point Analytics launches the beta of ImagePulse for predicting the financial status",
        date: "Jun 28, 2018",
        year: 2018,
        subheading: "Decimal Point Analytics (DPA) today announced that it has achieved a major breakthrough in Image analysis using Deep Learning networks. DPA has launched the beta of ImagePulse, its multi-layer convolutional neural network which is able to predict the financial status of a household by processing the images of the household."
    },
    {
        type: "external",
        link: "https://www.prlog.org/12726317-decimal-point-analytics-unveils-new-credit-risk-management-framework-at-the-prmia-event-in-mumbai.html",
        imgsrc: news4,
        heading: "Decimal Point Analytics unveils new credit risk management framework at the PRMIA event in Mumbai",
        date: "Aug 28, 2018",
        year: 2018,
        subheading: "Decimal Point Analytics(DPA) unveiled a new credit risk management framework at the PRMIA (Professional Risk Managers' International Association) event on 'Resiliency through Effective Risk Management in India' at BKC, Mumbai."
    },
    {
        type: "external",
        link: "https://www.openpr.com/news/1238419/decimal-point-releases-an-infographic-on-chinese-auto-finance-market.html",
        imgsrc: news4,
        heading: "Decimal Point releases an Infographic on Chinese Auto Finance Market",
        date: "Sep 14, 2018",
        year: 2018,
        subheading: "Decimal Point Analytics has released an Infographic about the Chinese Auto Finance Market. China is the largest automobile market in the world in terms of demand and supply with a market size of RMB 1.0 trillion in 2016. The Chinese auto finance industry is flourishing with auto finance penetration expected to reach ~50% by 2020."
    },
    {
        type: "external",
        link: "https://www.prlog.org/12653914-weekly-digest-india-heading-towards-deflation.html",
        imgsrc: news4,
        heading: "India Heading Towards Deflation",
        date: "Jul 24, 2017",
        year: 2017,
        subheading: "In this edition, it has reflected on the Indian CPI which has been declared at 1.54% for June'17. This is the first time inflation has breached RBI's band of 2% to 6% which is an indicator that India is headed towards deflation."
    },
    {
        type: "external",
        link: "https://etradewire.com/news/decimal-point-analytics-launches-singularitypulse-an-ai-focused-newsletter",
        imgsrc: news4,
        heading: "Decimal Point Analytics launches SingularityPulse – An AI focused newsletter",
        date: "Nov 09, 2017",
        year: 2017,
        subheading: "Decimal Point Analytics today announced the launch of SingularityPulse, a weekly newsletter focused on Artificial Intelligence. This newsletter will cover the latest usage and application of Machine Learning, Big Data and Natural Language processing in diverse industries across the globe."
    },
    {
        type: "external",
        link: "https://www.prdistribution.com/nbherard.com/decimal-point-analytics-has-launched-a-research-management-portal",
        imgsrc: news4,
        heading: "Decimal Point Analytics has launched a ‘Research Management Portal’",
        date: "Nov 10, 2017",
        year: 2017,
        subheading: "Decimal Point Analytics today announced the launch of a ‘Research Management Portal’ which will help financial services firms to comply with the up-coming MiFID II regulatory requirements in UK and Europe. Investor protection and Research unbundling are critical compliance requirement under the MiFID II regulations."
    },
    {
        type: "external",
        link: "https://www.openpr.com/news/866247/bitcoin-market-an-apology-for-blockchain.html",
        imgsrc: news4,
        heading: "Bitcoin Market, An Apology for Blockchain",
        date: "Dec 19, 2017",
        year: 2017,
        subheading: "Decimal Point Analytics has published its weekly digest on 18 December titled “Bitcoin Market, An Apology for Blockchain”. In this article it has posit a question, if the ongoing frenzy for Bitcoin crashes will that eventually cause users to shy away from the underlying technology of Blockchain?"
    },

];

export default Press_Release_data;